import React, {useState}                    from 'react';
import { useDispatch }                      from 'react-redux';
import numeral                              from 'numeral';
import { Popover, OverlayTrigger }          from 'react-bootstrap';

import { FontAwesomeIcon }                  from '@fortawesome/react-fontawesome';
import { faCaretDown }                      from '@fortawesome/free-solid-svg-icons';
import PriceBreaks                          from './pricebreaks';

import { changeBomLineItemPricebreak }      from 'product_tabs/tab_parts/bomSlice';
import { getBomLineItemPricebreak }         from 'product_tabs/tab_parts/utils/extracters';
import { parsePricebreaksFromPart }         from 'product_tabs/tab_parts/utils/part_suppliers';

const UnitPrice = (props) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const {
    index,
    board_qty,
    exact_qty,
    minimum_order_qty,
    markup,
    part,
    part_supplier_selected,
    unit_price,
    user_action,
    allow_edit,
  } = props
  
  if(!unit_price || unit_price <= 0) return <span>-</span>

  const popover_id = `bom-pricebreak-popover-basic-${index}`
  const link_id = `bom-pricebreak-link-${index}`
  const selected_pricebreak = getBomLineItemPricebreak(part_supplier_selected, board_qty)
  const pricebreaks = parsePricebreaksFromPart(part, part_supplier_selected, board_qty, exact_qty, minimum_order_qty, markup)

  const onChangePricebreak = (idx) =>{
    setShow(false)
    dispatch(changeBomLineItemPricebreak({
      idx: index,
      board_qty,
      data: pricebreaks[idx],
    }))
  }

  const onClickAction = (e) => {
    e.preventDefault()
    setShow(!show)
  }

  const onHidePopover = () => {
    if(!$(`#${popover_id} .popover-body:hover`).length > 0){
      setShow(false)
    }else{
      $(`#${link_id}`).focus()
    }
  }

  const popover = (
    <Popover id={popover_id}>
      <Popover.Body>
        <div className="popover-bom-line-item-pricebreaks">
          <PriceBreaks
            pricebreaks={pricebreaks}
            selected_pricebreak={selected_pricebreak}
            onChangePricebreak={onChangePricebreak}
            allowSelect={true}/>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <div className="bom-line-item-unit-price d-flex justify-content-end align-items-center">
      {user_action == 'buy' && allow_edit && 
        <OverlayTrigger trigger="click" placement="bottom" overlay={popover} show={show}>
          <a href='#' className="" id={link_id}
            onClick={onClickAction} 
            onBlur={onHidePopover}>
            <span>
              ${numeral(unit_price).format('0.0000')} <i className=""><FontAwesomeIcon icon={faCaretDown}/></i>
            </span>
          </a>
        </OverlayTrigger>
      }
      {(user_action == 'buy_stock' || !allow_edit) && 
        <span>
          ${numeral(unit_price).format('0.0000')}
        </span>
      }
    </div>
  )
};

UnitPrice.defaultProps = {
  allowSelectPriceBreak: false, // allow select price break from the list (radios)
}

export default UnitPrice;
